export function pasteImgListener(e) {
  let item = Array.from(e.clipboardData.items).find((x) =>
    /^image\//.test(x.type)
  );

  if (item) {
    let blob = item.getAsFile();
    let img = new Image();
    img.src = URL.createObjectURL(blob);

    const results = { imgSrc: img.src, blob: blob };
    return results;
  } else {
    return;
  }
}
